
export interface ChatUserSummary {
  /** @nullable */
  avatarUrl?: string | null;
  displayName: string;
  userId: string;
  userName: string;
}
